import styled from 'styled-components';

export const ExitOrEntry = styled.div`
  display: flex;
  align-items: center;
  gap: .5rem;
`